import { getToken } from './auth';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000/api';

export function urlImagemBlog(id) {
  return id ? `${API_URL}/blog/imagens/${id}` : null;
}

export async function listarImagensBlogDisponiveis() {
  const res = await fetch(`${API_URL}/blog/imagens-disponiveis/lista`, {
    headers: { Authorization: `Bearer ${getToken()}` }
  });
  if (!res.ok) throw new Error('Erro ao listar imagens do blog');
  return res.json();
}

export async function listarPostsPublicos() {
  const res = await fetch(`${API_URL}/blog/publico`);
  if (!res.ok) throw new Error('Erro ao buscar posts do blog');
  return res.json();
}

export async function obterPostPublico(slug) {
  const res = await fetch(`${API_URL}/blog/publico/${encodeURIComponent(slug)}`);
  if (!res.ok) throw new Error('Post não encontrado');
  return res.json();
}

export async function listarPostsAdmin() {
  const res = await fetch(`${API_URL}/blog`, {
    headers: { Authorization: `Bearer ${getToken()}` }
  });
  if (!res.ok) throw new Error('Erro ao listar posts');
  return res.json();
}

export async function obterPostAdmin(id) {
  const res = await fetch(`${API_URL}/blog/${id}`, {
    headers: { Authorization: `Bearer ${getToken()}` }
  });
  if (!res.ok) throw new Error('Erro ao buscar post');
  return res.json();
}

export async function criarPost(data) {
  const res = await fetch(`${API_URL}/blog`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${getToken()}`
    },
    body: JSON.stringify(data)
  });
  const body = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(body.error || 'Erro ao criar post');
  return body;
}

export async function atualizarPost(id, data) {
  const res = await fetch(`${API_URL}/blog/${id}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${getToken()}`
    },
    body: JSON.stringify(data)
  });
  const body = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(body.error || 'Erro ao atualizar post');
  return body;
}

export async function eliminarPost(id) {
  const res = await fetch(`${API_URL}/blog/${id}`, {
    method: 'DELETE',
    headers: { Authorization: `Bearer ${getToken()}` }
  });
  const body = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(body.error || 'Erro ao eliminar post');
  return body;
}

export async function enviarImagemBlog(ficheiro) {
  const formData = new FormData();
  formData.append('imagem', ficheiro);
  const res = await fetch(`${API_URL}/blog/imagens`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${getToken()}` },
    body: formData
  });
  const body = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(body.error || 'Erro ao enviar imagem');
  return body;
}
